<template>
  <div class="grid-wrapper" v-if="content" v-editable="content">
    <h2 v-html="content.title"></h2>
    <div class="grid-seminaire">
      <ul>
        <li v-for="(blok) in content.body" :key="blok._uid">
          <div class="bg" :style="{backgroundImage: `url(${blok.img})`}">
            <div class="pin">
              <img :src="blok.pin_icon" alt="pin image">
              <p v-html="blok.pin_text"></p>
            </div>
            <div class="text">
              <h3 v-html="blok.title"></h3>
              <p v-html="blok.text"></p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      content: null
    }
  };
</script>

<style lang="scss">
  .grid-wrapper {
    h2 {
      text-align: center;
      width: 100%;
      color: white;
    }
  }

  .grid-seminaire {
    width: 100%;
    padding: 20px;

    ul {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 20px;

      li {
        height: 300px;
        overflow: hidden;
        border-radius:3px;

        .bg {
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
          height: 100%;
          position: relative;
        }

        .pin {
          position: absolute;
          right: 0;
          top: 0;
          background-color: rgb(94, 194, 108);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          color: #fff;
          border-bottom-left-radius: 10px;
          padding:10px;
          p {
            padding-top:7px;
          }

          img {
            width: 35px;
            height: auto;
          }
        }
        .text {
          position: absolute;
          right:0;
          bottom:0;
          color:#fff;
          background:rgba(0,0,0,0.4);
          padding:20px 10px;
          p {

          }
          h3 {

          }
        }
      }
    }

  }

  @media screen and (max-width:1000px) {
    .grid-seminaire {
      ul {
        grid-template-columns: repeat(1, 1fr);
      }
    }
  }
</style>
